import { customElement } from '@aurelia/runtime-html';
import * as __au2ViewDef from './middle-body.html';
import {IDisposable, inject} from "aurelia";
import {SelectedObjectService} from "../../resources/services/selected-object";
import {EventAggregator} from "@aurelia/kernel";

@customElement(__au2ViewDef)
@inject(SelectedObjectService)
@inject(EventAggregator)
export class MiddleBody {
    //public selectedTab: string;
    private subscription: IDisposable;

    private tabDefinitions = [
        {
            label: "General",
            types: [
                "SceneType",
                "Class",
                "RelationClass",
                "Port",
                "Attribute",
                "AttributeType",
                "User",
                "UserGroup",
                "Procedure"
            ],
        },
        {
            label: "Attributes",
            types: ["SceneType", "Class", "RelationClass", "Port"],
        },
        {label: "Classes", types: ["SceneType"]},
        {label: "Relations", types: ["RelationClass"]},
        {label: "Ports", types: ["SceneType", "Class", "RelationClass"]},
        {label: "Reference", types: ["AttributeType"]},
        {label: "Table", types: ["AttributeType"]},
        {label: "RelationClasses", types: ["SceneType"]},
        {label: "Read Right", types: ["UserGroup"]},
        {label: "Write Right", types: ["UserGroup"]},
        {label: "Delete Right", types: ["UserGroup"]},
        {label: "Can Create Instance", types: ["UserGroup"]},
        {label: "User Groups", types: ["User"]},
        {label: "Procedures", types: ["SceneType"]},
    ];

    constructor(
        private selectedObjectService: SelectedObjectService,
        private eventAggregator: EventAggregator,
    ) {
    }

    get visibleTabs() {
        return this.tabDefinitions.filter((tab) =>
            tab.types.includes(this.selectedObjectService.type),
        );
    }

    binding() {
        this.subscription = this.eventAggregator.subscribe(
            "SelectedObjectChanged",
            () => {
                this.initialize()
            },
        );
    }

    attached() {
        this.initialize(); // Initial setup
    }

    clickedTab(tabName: string) {
        this.selectedObjectService.selectedTab = tabName;
    }

    detaching() {
        this.subscription.dispose();
    }

    private initialize() {
        if (this.selectedObjectService.selectedObject) {
            this.clickedTab("General");
        }
    }
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = MiddleBody;

    // @ts-ignore
    const proto = MiddleBody.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }